/* Sign-up and onboarding (PLAT-08, SAFE-04): signed-out start, sign-in, password reset and the five-step
   flow. Public and bare (no shell). The shell's auth gate sends signed-out users to /welcome; what the
   shell needs is exported from './gate' (aliases for API redirect URLs, onboarding resume). */
import { lazy } from 'react';
import { UserPlus } from 'lucide-react';
import { defineFeature } from '../../app/feature';

export default defineFeature({
  id: 'welcome',
  title: 'Sign-up & onboarding',
  short: 'Welcome',
  icon: UserPlus,
  group: 'Account',
  route: '/welcome',
  public: true,
  bare: true,
  screen: lazy(() => import('./Screen.tsx')),
  capabilities: ['PLAT-08', 'SAFE-04', 'SAFE-09'],
});
